/*=========================================================================================
  File Name: moduleMapActions.js
  Description: Map Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Api from "@/helpers/api.js";
import IndexedDB from "@/helpers/IndexedDB.js";
import store from "@/store";

export default {
	saveChangeNavbarColor({commit}, val) {
		return new Promise(async (resolve, reject) => {
			try {
				const userInfo = JSON.parse(localStorage.getItem("userInfo"));
				const primaryColor = store.state.themePrimaryColor;
				const updated = await IndexedDB.update("app_setting", {navbarColor: val, primaryColor}, userInfo.uid);
				commit("CHANGE_NAVBAR_COLOR", val);
				store.commit("UPDATE_PRIMARY_COLOR", val);
				resolve(updated);
			} catch (error) {
				reject(error);
			}
		});
	},
	async changeNavbarColor({commit}, val) {
		try {
			commit("CHANGE_NAVBAR_COLOR", val);
		} catch (error) {
			throw new Error(error);
		}
	},
	async saveNavbarColorOnIndexedDB({state, commit, dispatch}) {
		try {
			const userInfo = JSON.parse(localStorage.getItem("userInfo"));
			let navbarColor = state.navbarColor;
			const val = await dispatch("validate", userInfo.uid);
			if (val) {
				await IndexedDB.update("app_setting", {navbarColor: val.color}, userInfo.uid);
				commit("CHANGE_NAVBAR_COLOR", val.navbarColor);
			} else {
				await IndexedDB.save("app_setting", {navbarColor: navbarColor}, userInfo.uid);
				commit("CHANGE_NAVBAR_COLOR", navbarColor);
			}
		} catch (error) {
			throw new Error(error);
		}
	},
	async saveColorsOnIndexedDB({state, commit, dispatch}, color) {
		const {navbar_color, primary_color, text, url_logo} = color;
		return new Promise(async (resolve, reject) => {
			try {
				const userInfo = JSON.parse(localStorage.getItem("userInfo"));
				const val = await dispatch("validate", userInfo.uid);
				let primaryColor = "";
				let navbarColor = "";
				if (val) {
					primaryColor = primary_color || val.primaryColor;
					navbarColor = navbar_color || val.navbarColor;
					await IndexedDB.update("app_setting", {primaryColor, navbarColor}, userInfo.uid);
					commit("CHANGE_NAVBAR_COLOR", navbarColor);
					store.commit("UPDATE_PRIMARY_COLOR", primaryColor);
				} else {
					primaryColor = primary_color || store.state.themePrimaryColor;
					navbarColor = navbar_color || state.navbarColor;
					await IndexedDB.save("app_setting", {primaryColor, navbarColor}, userInfo.uid);
					commit("CHANGE_NAVBAR_COLOR", navbarColor);
					store.commit("UPDATE_PRIMARY_COLOR", primaryColor);
				}
				resolve({primaryColor, navbarColor});
			} catch (error) {
				reject(error);
			}
		});
	},
	async getCurrentNavbarColorFromIndexedDB({state}) {
		const navbarColor = await IndexedDB.getKey("app_setting", "navbarColor");
		if (navbarColor.hasOwnProperty("color")) {
			return navbarColor.color;
		} else {
			return state.navbarColor;
		}
	},
	closeMapSideBar({commit}) {
		commit("CLOSE_MAP_SIDEBAR");
	},
	openMapSideBar({commit}) {
		commit("OPEN_MAP_SIDEBAR");
	},
	changeToggleMapSidebar({commit}, val) {
		commit("TOGGLE_MAP_SIDEBAR", val);
	},
	openPopupStreeView({commit}, val) {
		commit("OPEN_STREETVIEW", val);
	},
	closePopupRouteLegends({commit}, val) {
		commit("TOGGLE_ROUTES_LEGENDS", val);
	},
	changeMapStyle({commit}, theme) {
		commit("CHANGE_MAP_STYLE", theme.name);
	},
	changeTrafficLayer({commit}, val) {
		commit("CHANGE_TRAFFIC_LAYER", val);
	},
	getExecutedRoute({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/executed/route", payload)
				.then((response) => {
					commit("SET_EXECUTE_ROUTE", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	geocoder({commit}, {country, city, address, department}) {
		const payload = {country, city, address, department};
		return new Promise((resolve, reject) => {
			Api.post("/geocoder", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	geoinverso({commit}, {country, cy, cx}) {
		const payload = {country, cy, cx};
		return new Promise((resolve, reject) => {
			Api.post("/geoinverso", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	geMapConfig() {
		return IndexedDB.getAll("app_setting");
	},
	validate({state, commit, dispatch}, uid) {
		return IndexedDB.getKey("app_setting", uid);
	},
};
